import CanalEmailModel from './CanalEmailModel'

export default class CanalEmailImapSmtpModel extends CanalEmailModel {
  constructor({
    id = 0,
    canalId = 0,
    nome = '',
    descricao = '',
    username = '',
    password = '',
    imapHost = '',
    imapPort = 0,
    smtpHost = '',
    smtpPort = 0,
  } = {}) {
    super(canalId, nome, descricao)
    this.id = id
    this.username = username
    this.password = password
    this.imapHost = imapHost
    this.imapPort = imapPort
    this.smtpHost = smtpHost
    this.smtpPort = smtpPort
  }
}
